"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdkStateService = void 0;
const services_definitions_1 = require("@wix/services-definitions");
const definition_1 = require("@wix/viewer-service-named-signals/definition");
const definition_2 = require("../definition");
exports.SdkStateService = (0, services_definitions_1.implementService)(definition_2.SdkStateDefinition, ({ getService }) => {
    const { signal } = getService(definition_1.NamedSignalsDefinition);
    const compStates = {};
    return {
        for: (componentId) => {
            if (!compStates[componentId]) {
                compStates[componentId] = {};
            }
            const compState = compStates[componentId];
            const getSignal = (key, defaultValue) => {
                if (!compState[key]) {
                    compState[key] = signal(defaultValue, `${componentId}/${key}`);
                }
                return compState[key];
            };
            return {
                getSignal,
                get: (key, defaultValue) => getSignal(key, defaultValue).get(),
                set: (key, value) => getSignal(key, value).set(value),
            };
        },
    };
});
//# sourceMappingURL=sdkStateService.js.map